import React from "react";
import { Container } from "./styled/mls-disclaimer";
function MlsDisclaimer(_a) {
    var disclaimer = _a.disclaimer;
    return (React.createElement(Container, { dangerouslySetInnerHTML: {
            __html: disclaimer
                .replace(/&reg;/g, "<sup>&reg;</sup>")
                .replace(/®/g, "<sup>&reg;</sup>")
                .replace(/&copy;/g, "<sup>&copy;</sup>")
                .replace(/©/g, "<sup>&copy;</sup>")
                .replace(/&trade;/g, "<sup>&trade;</sup>")
                .replace(/™/g, "<sup>&trade;</sup>")
        } }));
}
export default MlsDisclaimer;
